import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBubbleWide"><Path d="M2.75 6.75C2.75 5.09315 4.09315 3.75 5.75 3.75H18.25C19.9069 3.75 21.25 5.09315 21.25 6.75V15.25C21.25 16.9069 19.9069 18.25 18.25 18.25H15.3759C15.143 18.25 14.9173 18.3313 14.738 18.4799L12.6397 20.2183C12.2679 20.5263 11.7292 20.5248 11.3593 20.2147L9.29422 18.4836C9.11418 18.3327 8.88675 18.25 8.65182 18.25H5.75C4.09315 18.25 2.75 16.9069 2.75 15.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBubbleWide;
